import http, { httpWithout401 } from './http';

const TTL = 60000;
const cache = new Map();

const clearCacheOnWrite = (response) => {
    if ((response.config?.method || 'get').toLowerCase() !== 'get') {
        cache.clear();
    }

    return response;
};

http.interceptors.response.use(clearCacheOnWrite);
httpWithout401.interceptors.response.use(clearCacheOnWrite);

export const cachedGet = (url, client = http) => {
    const entry = cache.get(url);
    if (entry && entry.expires > Date.now()) {
        return entry.promise;
    }

    const promise = client.get(url).catch((error) => {
        cache.delete(url);
        throw error;
    });

    cache.set(url, { promise, expires: Date.now() + TTL });

    return promise;
};
